export const shouldTrack = onTrack => {
  return onTrack && typeof onTrack === 'function';
};